module.exports = __webpack_public_path__ + "explore/Components/ExploreHeader/magnifying-glass--mobile.0f55df25fe367de0f1948482ba7339a6.svg";